import type { RowVariantDefinition } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defineRowVariantRegistry } from '@/deskUiSkeletons/rowTemplates/RowVariantRegistry'
import { sharedChatAnswerVariant } from '@/msgComponents/rowVariants/Chat/Chat'
import { productRowVariantForPath, productRowVariantsForPath } from '../../../productDisplayCatalog'
import { HackernewsCommentTemplate } from './variants/HackernewsComment'
import { HackernewsSlideTemplate } from './variants/HackernewsSlide'

const commentVariant = {
  ...productRowVariantForPath('hackernews', 2),
  Template: HackernewsCommentTemplate,
} as const satisfies RowVariantDefinition

const slideVariant = {
  ...productRowVariantForPath('hackernews', 3),
  Template: HackernewsSlideTemplate,
} as const satisfies RowVariantDefinition

const productRows = productRowVariantsForPath('hackernews')

export const rowVariantRegistry = defineRowVariantRegistry({
  answers: {
    variants: [commentVariant, slideVariant, sharedChatAnswerVariant],
    fallback: productRows.answers.fallback,
  },
  submsges: {
    variants: [commentVariant, slideVariant],
    fallback: productRows.submsges.fallback,
  },
})
